var __isp_options = {
	isp_serp_disable_images_lazy_load: true,
	isp_serp_callback: function(data,facets_only) {
	isp_setProductNames();
	isp_setSaleColor();
	isp_setSoldOutBanner();
	isp_setQuickView();
	isp_setPrices();
	isp_setHref();
    isp_fixSizeFacetName();
    let products = document.querySelectorAll('.isp_grid_product')
    products.forEach(productItem => {
      let product_Id = productItem.getAttribute('product_id')
      productItem.setAttribute('data-product-id', product_Id)
      WishlistKing.observe({
        selector: ".isp_grid_product[data-product-id]",
      },
      (target) => {
        target.append(
          WishlistKing.createComponent("wishlist-button-floating", {
            id: target.container.getAttribute("data-product-id"),
          })
        );
      }
      );
    }) 
	}, //search results rendered
	// isp_serp_no_results_callback: function() {}, // *no* results
	// isp_add_to_cart_callback: function(product_id, form_id) {},
	isp_serp_quickview_callback: function() {
		isp_setProductNames();
		isp_setSaleColor();
		isp_setSoldOutBanner();
	},  //Quick View opened
	// isp_serp_look_a_like_txt: 'Related...', //Button text
	// STAR_REVIEWS_POSITION: 1, //Above or under price
	// isp_serp_articles_tab_name: 'Blog Posts', // CMS tab name
	// isp_dropdown_callback: function(li_element) {}, //Dropdown item
	// dropdown_align_inputbox: 'right', // Drodown alignment
	// dropdown_narrow_by: [], // Filtered search query parameters (JSON)
	// AVOID_POP_PRODUCTS_PRELOAD: false
};

__isp_options.variant_color_attributes = ['watch color', 'strap color'];

var isp_related_options = {
// isp_related_callback: function() {}, //Recommendations rendered
// DISABLE_EXEC_SLIDE: true, // Whether slider is not initialize
// LAZYLOAD: "progressive", // Whether to load images in advance
PRICE_FROM_ALWAYS: false, // Whether to render from price wording
DECIMALS_REMOVE_ON_ROUND_PRICES: true, // whether to remove .00
RANDOMIZE: true, // whether to add extra randomization
DISABLE_ISP_QS: true
}

// var acp_magento_options = {
// search_element_id: 'element_id_1,element_id_2' // Force IS+ to attach only to this these input IDs
// }

function isp_setQuickView() {
jQuery('a.isp_product_quick_view_button').html('<span class="icon-plus"></span>');
}

function isp_setSaleColor() {
jQuery('.isp_product_price_wrapper .isp_compare_at_price, .isp_quick_view_price_wrapper .isp_compare_at_price').each(function(idx) {
var ths = jQuery(this);
ths.next('.isp_product_price').css('color', 'red');
});
}

function isp_fixSizeFacetName() {
    jQuery('span.isp_facet_title_name').each(function(idx, el) {
        if ($(el).text() === 'Size_') {
            $(el).text('Size');
        }
    });
    // mobile
    jQuery('span.isp_facet_group_title_text').each(function(idx, el) {
        if (($(el).text()+"").indexOf('Size_') !== false) {
            $(el).text($(el).text().replace('Size_', 'Size'));
        }
    });
}

function isp_setPrices() {
    jQuery('#isp_search_results_container span.money').each(function(idx, el) {
        var ths = jQuery(el);
        var thsText = jQuery(el).text();
        if(thsText.indexOf('.00') > -1) {
            jQuery(el).text(thsText.replace('.00', ''));
        }
    });

    jQuery('#isp_search_results_container .cbb-price-digits').each(function(idx, el) {
        var ths = jQuery(el);
        var thsText = jQuery(el).text();
        if(thsText.indexOf('.00') > -1) {
            jQuery(el).text(thsText.replace('.00', ''));
        }
    });


    var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
    var list = document.querySelector('span.money');

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            jQuery('#isp_search_results_container .cbb-price-digits').each(function(idx, el) {
                var ths = jQuery(el);
                var thsText = jQuery(el).text();
                if(thsText.indexOf('.00') > -1) {
                    jQuery(el).text(thsText.replace('.00', ''));
                }
            });
        });
    });

    // To be checked this code it throw error related to observe 

    // observer.observe(list, {
    //     attributes: true,
    //     childList: true,
    //     characterData: true
    // });
}

function isp_setProductNames() {
jQuery('#isp_search_results_container .isp_product_title, .products .thumbnail .info .title').each(function(idx, el) {
// el.closest(".isp_product_info").setAttribute('data-product-id', "isp")
var ths = jQuery(el);
str = ths.text().toLowerCase().replace(/\b[a-z]/g, function(letter) {
return letter.toUpperCase();
});
str = str.replace('Iii', 'III').replace('Xl', 'XL').replace('Xs','XS').replace('Ip', 'IP').replace('Fx','FX').replace('Led', 'LED').replace('Ss', 'SS');
if(str.endsWith('Pos')) {
    str = str.replace(new RegExp('Pos$'), 'POS');
}
str = str.replace("’S", "’s");
ths.text(str);
});

}

function isp_setSoldOutBanner() {
    jQuery('.isp_sold_out_banner_container').each(function(idx, el) {
var ths = jQuery(el);
// var newHtml = '<img src="//www.freestyleusa.com/cdn/shop/t/212/assets/label-sold-out.png?v=131646786530346052491743620268" class="sold-out-label" />';
var newHtml = '';
ths.html(newHtml);
});
}

// function isp_setSearchboxPlaceholderText() {
//     jQuery('#isp_main_search_box').attr('placeholder', isp_searchbox_placeholder_text);
// }

function isp_setHref() {
    if(typeof collectionTitle !== 'undefined') {
        if(collectionTitle.length) {
            jQuery('#isp_search_results_container a[href^="/products/"').each(function(idx, el) {
                var href = jQuery(el).attr('href');
                jQuery(el).attr('href', '/collections/' + collectionTitle + href);
            });
        }
    }
}

jQuery(window).on('load', function() {
    isp_setProductNames();
    isp_setSaleColor();
    isp_setPrices();
    isp_setSoldOutBanner();
    isp_setHref();
    if(jQuery('a.isp_product_quick_view_button').length) {
        isp_setQuickView();
    }
});

// jQuery(document).ready(function() {
//     setTimeout(function() {
//         if(countdown.length) {
//             jQuery(countdown).css({'top': '25px', 'position': 'fixed'});

//         }
//     }, 4500);
// });

var setCountdownBar = function() {
  var windowWidth = jQuery(window).width();
  if (windowWidth <= 768) {
    if (jQuery('#epb_bar').length > 0) {
        // var epbHeight = jQuery('#epb_container').height();
	    var epbHeight = 27;
        jQuery('#epb_bar').css({'top': 0, 'position': 'fixed'});
        jQuery('.header-and-menu').css('top', Math.max.apply(Math,[epbHeight, 0]));

        // jQuery('[data-open-accessibility-text-original]').attr('data-open-accessibility-text-original', '6px');

        jQuery('#epb_close').click(function() {
            jQuery('.header-and-menu').css('top', 0);
            jQuery('#epb_container').remove();
        });

    } else {
        setTimeout(function() {
            setCountdownBar();
        }, 500);
    }
  } else {
    if (jQuery('#epb_bar').length > 0) {
        // jQuery('#epb_container').css('top', 0);
      	// jQuery('.global-wrapper').css('margin-top', 40);
        // jQuery('#fs-top-desktop').css('height', 25);

        // jQuery('[data-open-accessibility-text-original]').attr('data-open-accessibility-text-original', '9px');
        // jQuery('#epb-flip-clock > *').css({'font-size': '20px', 'height:', '30px'});

      	jQuery('#epb_close').click(function() {
            // jQuery('.global-wrapper').css('padding-top', '');
        });
    } else {
        setTimeout(function() {
            setCountdownBar();
        }, 500);
    }
  }
}
jQuery(document).ready(function() {
    setCountdownBar();
});
